import URC from 'ui-react-common';
import * as types from './action-types';

const api = URC.services.coreAPIInstance;

const submitEmailUpdate = (formData) => ({
    asyncAction: () => api.emailUpdate(formData).then((response) => response),
    type: types.EMAIL_UPDATE,
});

const receivedEmailUpdateSuccess = (res) => ({
    type: types.EMAIL_UPDATE_SUCCESS,
    res,
});

export default {
    submitEmailUpdate,
    receivedEmailUpdateSuccess
};
